<div class="popover-wrapper">
    <div class="popover-header">{{title}}</div>
    <div class="layout-container">
        <kve-margin-input></kve-margin-input>
    </div>
</div>
